export default __webpack_public_path__ + "static/media/waterman.bd7114c8.png";